import React from 'react';
import PropTypes from 'prop-types';
// common
import CustomButton from './../../../common/Forms/CustomButton/CustomButton';
import Loader from './../../../common/Loader/Loader';
// scss
import './../../../common/CommonList/Table.scss';

const columns = [
	{
		key: null,
		label: 'S.No'
	},
	{
		key : 'firstname',
		secKey: 'lastname',
		label : 'Name'
	},
	{
		key: 'email',
		label: 'E-Mail'
	}
];

const UserTable = ({ userList, manageUser }) => {
	if (userList && userList.length > 0) {
		return (
			<table className="table UserTable">
				<thead>
					<tr>
						{columns.map((item, i) => (
							<th key={i} id={item.key}>{item.label}</th>
						))}
						<th></th>
					</tr>
				</thead>
				<tbody>
					{userList.map((item, i) => (
						<tr key={i}>
							{columns.map((column, j) => {
								if (!column.key) {
									return <td key={j}>{i + 1}</td>;
								}
								return <td key={j}>{item[column.key]} {column.secKey && item[column.secKey]}</td>;
							})}
							<td className="text-right">
								<CustomButton
									iconOnly
									iconName='edit'														
									onClick={() => manageUser(true, 'edit', item.id)}
								/>
								<CustomButton
									iconOnly
									iconName='delete'									
									onClick={() => manageUser(true, 'delete', item.id)}
								/>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		);
	}
	return (<Loader />);
}

UserTable.propTypes = {
	userList: PropTypes.instanceOf(Array),
	manageUser: PropTypes.func
};

UserTable.defaultProps = {
	userList: [],
	manageUser: () => {}
};

export default UserTable;



// WEBPACK FOOTER //
// ./components/User/UserList/UserTable.js